import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import i18next from 'i18next';
import { getModalSwitch, getLoaderBtn, getConfirmModalSwitch } from '@app/store/actions';
import { store } from '.';
import { LifeTime } from '@app/models';
import _ from 'lodash';
import moment from 'moment';
import 'moment-duration-format';

export const handleModalSuccess = () => {
    store.dispatch(getModalSwitch(false));
    store.dispatch(getLoaderBtn(false));
    store.dispatch(getConfirmModalSwitch(true));
};

export const genericErrorToast = (error: AxiosError<any>) => {
    toast.error(genericErrorString(error));
};

export const genericErrorString = (error: any) => {
    if (error.response?.data.error) {
        return error.response.data.error.message;
    }
    if (error.response?.data?.errors?.length) {
        return error.response.data.errors[0].message;
    }
    else if (error.response?.message) {
        return error.response.message;
    }
    else if (error.response?.statusText) {
        return error.response.statusText;
    }
    else {
        return i18next.t('GENERIC_ERROR');
    }
};

export const calcDays = (lf: LifeTime): string => {
    let min: number = 0;

    if (typeof lf === 'string') {
        min = parseInt(lf);
    } else {
        min = lf;
    }

    const time = moment.duration(min, 'minutes');
    return time.humanize();
};

export const resolveOrgName = (orgId: string, orgs: any) => {
    if (orgId) {
        let org = _.find(orgs, { id: orgId });
        if (org) {
            return org.name;
        }
    }
    return null;
};